import React from "react";
import PropTypes from 'prop-types';
import { Player } from "../VideoPlayer/Player";

export default function YouTubeBlock(
    {
        url
    }) {

    return (
        <div className="mt-5 mb-10">
            <Player src={url} type="video/youtube"/>
        </div>
    )
}

YouTubeBlock.propTypes = {
    url: PropTypes.string.isRequired
}